module.exports = __webpack_public_path__ + "img/por.a560e1f2.svg";